var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcChevronDown = function SvgIcChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.17 8.16A.562.562 0 0 1 3.567 8c.15 0 .283.053.396.16l7.537 7.065 7.537-7.066A.562.562 0 0 1 19.433 8c.151 0 .284.053.397.16.227.212.227.548 0 .743l-7.933 7.438c-.227.212-.586.212-.794 0L3.17 8.903a.492.492 0 0 1 0-.744Z",
    fill: "currentColor"
  })));
};
export default SvgIcChevronDown;